import React, { useState } from "react"
import PropTypes from "prop-types"
import ReactDOM from "react-dom"
import { ThemeProvider } from "@material-ui/core"

import { getElementNode } from "../../services/elementNode"

import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Button from "@material-ui/core/Button"

import { makeStyles } from "@material-ui/core"

import SuccessIcon from "./SuccessIcon"
import ErrorIcon from "./ErrorIcon"
import WarningIcon from "./WarningIcon"

import theme from "../../styles/theme"

const useStyles = makeStyles(() => ({
	dialogContent: {
		display: "flex",
    flexDirection: "column",
    alignItems: "center"
	}
}))

const InfoModal = props => {
	const [visibility, setVisibility] = useState(true)
	const classes = useStyles()
	const { message, type, title } = props

	const buttonColor = {
		warning: "default",
		error: "primary",
		success: "secondary"
	}

	return (
		<ThemeProvider theme={theme}>
			<Dialog
				onClose={() => setVisibility(false)}
				open={visibility}
			>
				<DialogTitle style={{ textAlign: "center" }}>
					{title}
				</DialogTitle>
				<DialogContent dividers className={classes.dialogContent}>
					{type === "success" && <SuccessIcon />}
					{type === "warning" && <WarningIcon />}
					{type === "error" && <ErrorIcon />}
					<DialogContentText style={{ textAlign: "center", maxWidth: "100%", wordWrap: "break-word" }}>
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions style={{ justifyContent: "center" }}>
					<Button
						onClick={() => setVisibility(false)}
						color={buttonColor[type]}
						variant="contained"
					>
						Fechar
					</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>
	)
}

InfoModal.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf([PropTypes.node])
	]).isRequired,
	type: PropTypes.oneOf(["success", "error", "warning"]).isRequired,
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	title: PropTypes.string.isRequired
}

InfoModal.success = ({ message, title }) => {
	const InfoModalNode = getElementNode("info-modal")

  ReactDOM.render(<InfoModal message={message} title={title} type="success" />, InfoModalNode);
}

InfoModal.error = ({ message, title }) => {
	const InfoModalNode = getElementNode("info-modal")

  ReactDOM.render(<InfoModal message={message} title={title} type="error" />, InfoModalNode);
}

InfoModal.warning = ({ message, title }) => {
	const InfoModalNode = getElementNode("info-modal")

  ReactDOM.render(<InfoModal message={message} title={title} type="warning" />, InfoModalNode);
}

export default InfoModal
